import { useReducer } from "react"
import "lib/@hooks/useEvent"
import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { readScheduleEditorSession } from "../lib/schedule-editor-session"
import { AmendsChanged } from "../schedule-editor-event-definitions.mjs"

/** True only while the initial amends query is in flight. */
export function useScheduleEditorAmendsLoading() {
    const { draftId } = useScheduleEditorIds()
    const [, forceUpdate] = useReducer(tick, 0)

    AmendsChanged(draftId).useEvent(forceUpdate)

    const session = readScheduleEditorSession(draftId)

    return Boolean(session?.amendsInitialLoading)
}

function tick(n) {
    return n + 1
}
